import { render, staticRenderFns } from "./GSTDetails.vue?vue&type=template&id=2773cfea&scoped=true&"
import script from "./GSTDetails.vue?vue&type=script&lang=js&"
export * from "./GSTDetails.vue?vue&type=script&lang=js&"
import style0 from "./GSTDetails.vue?vue&type=style&index=0&id=2773cfea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2773cfea",
  null
  
)

export default component.exports